import { addStripedBackgroundStyles } from 'helpers/jobUtils';
import useToggleStyle from 'hooks/useToggleStyle';
import { useAppContext } from 'providers/AppProvider';
import { ErrorBoundary } from 'providers/ErrorBoundaryProvider';
import { JobProvider } from 'providers/JobContext';
import { useSettingsPanelContext } from 'providers/SettingsPanelProvider';
import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { Outlet, useLocation } from 'react-router-dom';
import UnauthorizedRedirectListener from 'components/common/UnauthorizedRedirectListener';

const App = () => {
  const { isStylesheetLoaded } = useToggleStyle();
  const { pathname } = useLocation();
  const {
    settingsPanelConfig: { showSettingPanelButton },
    setSettingsPanelConfig
  } = useSettingsPanelContext();

  const {
    config: { theme, isRTL }
  } = useAppContext();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    setSettingsPanelConfig({
      openSettingPanel: false
    });
  }, [isRTL]);

  useEffect(() => {
    addStripedBackgroundStyles();
  }, []);

  return (
    <>
      <ErrorBoundary>
        <UnauthorizedRedirectListener />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000
          }}
        />
        <JobProvider>
          {!isStylesheetLoaded ? (
            <div
              style={{
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundColor: theme === 'dark' ? '#000' : '#fff'
              }}
            />
          ) : (
            <>
              <Outlet />
              {showSettingPanelButton && <></>}
            </>
          )}
        </JobProvider>
      </ErrorBoundary>
    </>
  );
};

export default App;
